import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { Button, Modal, Spinner } from "react-bootstrap"; // Import react-bootstrap components
import OtpVerification from "./OtpVerification"; // Import OtpVerification for the next step
import axios from "axios"; // Import axios for API calls
import { validateEmail } from "../../../utils/validators"; // Import centralized validator

function ChangeEmailModal({ email, onClose }) {
    const { t } = useTranslation();
    const [newEmail, setNewEmail] = useState("");
    const [isOtpModalOpen, setIsOtpModalOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false); // State for loading spinner
    const language = localStorage.getItem("i18nextLng");

    const handleNext = async () => {
        if (!validateEmail(newEmail)) {
            toast.error(t("Please enter a valid email address."));
            return;
        }
        setIsLoading(true); // Show spinner while processing
        try {
            const res = await axios.get(`signup/email-duplicate-check?email=${newEmail}&lang=${language}`);
            if (res?.data?.statusCode !== 200) {
                toast.error(t("This email is already in use. Please provide a different email address."));
                setIsLoading(false);
                return;
            }
            await handleResendOTP(); // Call handleResendOTP after email check
        } catch (error) {
            toast.error(t("An error occurred while verifying the email. Please try again."));
        } finally {
            setIsLoading(false); // Hide spinner after processing
        }
    };

    const handleResendOTP = async () => { 
        if (!newEmail) {
            toast.error(t("Email not available. Please try again."));
            return;
        }
        try {
            setIsLoading(true); // Show spinner while processing
            await axios.post("settings/generate-otp", {
                type: 4,
                email: newEmail,
                lang: language,
            });
            toast.success(t("OTP has been successfully sent to ") + newEmail); // Show success message
            setIsOtpModalOpen(true); // Open OTP modal if OTP is sent successfully
        } catch (err) {
            toast.error(t("Failed to send OTP. Please try again."));
        } finally {
            setIsLoading(false); // Hide spinner after processing
        }
    };

    if (isOtpModalOpen) {
        return <OtpVerification onClose={onClose} email={newEmail} />;
    }

    return (
        <>
        <Modal show onHide={onClose} centered dialogClassName="small-modal"> {/* Add dialogClassName */}
            <Modal.Header closeButton>
                <Modal.Title>{t("Change Email Address")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>{t("Current Email")}: {email}</p>
                <input
                    type="email"
                    placeholder={t("Enter new email address")}
                    value={newEmail}
                    onChange={(e) => setNewEmail(e.target.value)}
                    style={{ width: "100%", padding: "8px", marginTop: "10px" }}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onClose}>
                    {t("Close")}
                </Button>
                <Button variant="primary" onClick={handleNext} disabled={isLoading}>
                    {isLoading ? <Spinner animation="border" size="sm" /> : t("Next")}
                </Button>
            </Modal.Footer>
        </Modal></>
    );
}

export default ChangeEmailModal;
